import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconRestaurantLine24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="restaurant line">
            <path
                d="M19.7071 1.70711C20.0976 1.31658 20.0976 0.683417 19.7071 0.292893C19.3166 -0.0976311 18.6834 -0.0976311 18.2929 0.292893L15.4645 3.12132C14.5268 4.059 14 5.33077 14 6.65685V8.99931C14 9.00031 14 9.002 14 9.003C14.0008 9.27463 14.1099 9.52079 14.2864 9.70055C14.2907 9.70494 14.2951 9.70929 14.2995 9.7136C14.3938 9.80626 14.502 9.87643 14.6172 9.92412C14.7343 9.97265 14.8625 9.9996 14.997 10C14.998 10 14.999 10 15 10H17.3431C18.6692 10 19.941 9.47322 20.8787 8.53553L23.7071 5.70711C24.0976 5.31658 24.0976 4.68342 23.7071 4.29289C23.3166 3.90237 22.6834 3.90237 22.2929 4.29289L19.4645 7.12132C18.9188 7.66695 18.1847 7.9807 17.4151 7.99914L21.7071 3.70711C22.0976 3.31658 22.0976 2.68342 21.7071 2.29289C21.3166 1.90237 20.6834 1.90237 20.2929 2.29289L16.0009 6.58493C16.0193 5.81534 16.333 5.08117 16.8787 4.53553L19.7071 1.70711Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.70711 0.292922C2.42111 0.00692445 1.99099 -0.0786313 1.61732 0.0761497C1.24364 0.230931 1 0.595567 1 1.00003V3.51475C1 5.37126 1.7375 7.15174 3.05025 8.4645L12.7929 18.2071C13.1834 18.5977 13.8166 18.5977 14.2071 18.2071L16 16.4142L22.2929 22.7071C22.6834 23.0977 23.3166 23.0977 23.7071 22.7071C24.0976 22.3166 24.0976 21.6834 23.7071 21.2929L2.70711 0.292922ZM3 3.41424L14.5858 15L13.5 16.0858L4.46447 7.05028C3.52678 6.1126 3 4.84083 3 3.51475V3.41424Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M7.67573 17.2372C8.08285 16.864 8.11035 16.2314 7.73716 15.8243C7.36397 15.4172 6.7314 15.3897 6.32428 15.7629L0.324281 21.2629C-0.0828378 21.636 -0.110341 22.2686 0.262852 22.6757C0.636044 23.0828 1.26861 23.1104 1.67573 22.7372L7.67573 17.2372Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
